import * as React from 'react';

import messages from 'library/displayMessages';
import { Icon, showErrorMessage } from 'ui/components';
import { WrappedMessage } from 'utils';

import { DiscussionsApi } from 'global/api';
import { ThreadWithPosts } from 'labxchange-client';
import { ClassroomDiscussionThreadInternal } from 'classrooms/components';
import { ThreadCardStats } from 'discussions/components/ThreadCard';


interface Props {
    itemId: string;
    loggedInUsername?: string;
}

interface State {
    thread?: ThreadWithPosts;
    showConversation: boolean;
}

export class DiscussionBox extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            showConversation: false,
        };
    }

    public async componentDidMount() {
        try {
            const thread = await DiscussionsApi.threadsThreadForItem({
                itemId: this.props.itemId,
                onlyThread: true,
            });
            this.setState({ thread });
        } catch (err) {
            showErrorMessage(<WrappedMessage message={messages.errorLoadingDiscussion} />, { exception: err });
        }
    }

    public async componentDidUpdate(prevProps: Props, prevState: State) {
        if (this.state.showConversation !== prevState.showConversation && this.state.showConversation) {
            this.loadData();
        }
    }

    private async loadData() {
        try {
            const thread = await DiscussionsApi.threadsThreadForItem({
                itemId: this.props.itemId,
            });
            this.setState({ thread });
        } catch (err) {
            showErrorMessage(<WrappedMessage message={messages.errorLoadingDiscussion} />, { exception: err });
        }
    }

    public render() {
        return (
            <div className='discussion-box rounded clearfix'>
                <div className='discussion-box-header'>
                    <div className='discussion-box-btn-container'>
                        <button className='btn-discussion-show' onClick={() => {
                            this.setState({
                                showConversation: !this.state.showConversation,
                            });
                        }}>
                            <p className='discussion-box-message'>
                                <Icon name='comment-discussion' className='mr-2' />
                                <WrappedMessage message={messages.discussionInvitation} />
                            </p>
                            <p>
                                <Icon name={this.state.showConversation ? 'chevron-up' : 'chevron-down'} className='mr-2' />
                            </p>
                        </button>
                    </div>
                    <ThreadCardStats
                        likeCount={this.state.thread?.thread.likeCount}
                        postCount={this.state.thread?.thread.postCount}
                        viewCount={this.state.thread?.thread.viewCount}
                        participantCount={this.state.thread?.thread.participantCount}
                    />
                </div>
                <div className='discussion-box-thread' style={{ display: this.state.showConversation ? 'initial' : 'none' }}>
                    {(this.state.thread && this.state.showConversation) &&
                        <ClassroomDiscussionThreadInternal
                            subCategoryId={this.state.thread.thread.subCategory}
                            threadId={this.state.thread.thread.id.toString()}
                            loggedInUsername={this.props.loggedInUsername}
                            hideFirstPost={true}
                            hideShareLikeButtons={true}
                            reversePosts={true}
                            onShare={() => { return null; }}
                            isAssetDiscussion={true}
                        />
                    }
                </div>
            </div>
        );
    }
}
